import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FaEye, FaEdit } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../../common/Pagination";
import Search from "../../../common/Search";
import { AiCallQuestionsList } from "../../../redux/services/Ai Services/Ai.Services";
import { activeLeadType, leadTypeLabel } from "../../../Utils/role";

function AiCallingBugsQusetions() {
    const navigate = useNavigate();
    const dispatch = useDispatch();        
    const [searchParams] = useSearchParams();
    const [search, setSearch] = useState("");

    const leadType = activeLeadType(searchParams.get("lead_type"));
    const typeLabel = leadTypeLabel(leadType);

    const { refreshData } = useSelector((state) => state.modal);

    const [questionsList, setQuestionsList] = useState([]);
    const [summary, setSummary] = useState({ total: 0, open: 0, filter: "" });
    const [initialLoading, setInitialLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(100);
    const [totalPages, setTotalPages] = useState(1);

    const fetchQuestions = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) setInitialLoading(true);
            else setTableLoading(true);

            const payload = {
                lead_type: leadType || undefined,
                page: pageNo,
                per_page: limit,
            };

            const res = await AiCallQuestionsList(payload);

            const body = res?.data?.data || res?.data || {};
            const list = Array.isArray(body?.questions) ? body.questions : [];

            setQuestionsList(list);
            setSummary({
                total: body?.total ?? list.length,
                open: body?.open ?? 0,
                filter: body?.filter ?? "",
            });

            const tp = Math.max(1, Math.ceil((body?.total || list.length) / limit));
            setTotalPages(tp);
        } catch (err) {
            console.log("Questions API error:", err);
            setQuestionsList([]);
            setSummary({ total: 0, open: 0, filter: "" });
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
            setPage(newPage);
            fetchQuestions(newPage, false);
        }
    };

    useEffect(() => {
        fetchQuestions(1, true);
    }, [refreshData, limit, leadType]);

    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    const filteredList = questionsList.filter((item) => {
        if (!search.trim()) return true;
        const q = search.trim().toLowerCase();
        return [item.question, item.answer, item.status, item.lead_type]
            .filter(Boolean)
            .join(" ")
            .toLowerCase()
            .includes(q);
    });

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>
                       Associate Ai Calling Questions
                    </h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>
                            {typeLabel
                                ? `${typeLabel} AI Calling Questions`
                                : "AI Calling Questions"}
                        </span>
                    </nav>
                </div>
            </div>

            <div className="main_page">
                <div className="row g-3 mb-3">
                    <div className="col-12 col-lg-6">
                        <div className="st-wrapper-card p-3 text-start">
                            <div className="text-muted">Total Questions</div>
                            <h4 className="mb-0">{summary.total}</h4>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="st-wrapper-card p-3 text-start">
                            <div className="text-muted">Open</div>
                            <h4 className="mb-0">{summary.open}</h4>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                    <Search
                        search={search}
                        placeholder="Search question ..."
                        onSearch={(value) => {
                            setSearch(value);
                            setPage(1);
                        }}
                    />
                    {totalPages > 1 && (
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>

                <div className="st-wrapper-card text-center">
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Question</th>
                                    <th>Answer</th>
                                    <th>Lead Type</th>
                                    <th>Times Asked</th>
                                    <th>Status</th>
                                    <th>Asked At</th>
                                    <th>Answered At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tableLoading ? (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : filteredList.length > 0 ? (
                                    filteredList.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{index + 1}</td>
                                            <td
                                                style={{
                                                    maxWidth: "320px",
                                                    whiteSpace: "normal",
                                                    textAlign: "left",
                                                }}
                                            >
                                                {item.question || "-"}
                                            </td>
                                            <td
                                                style={{
                                                    maxWidth: "240px",
                                                    whiteSpace: "normal",
                                                    textAlign: "left",
                                                }}
                                            >
                                                {item.answer || "-"}
                                            </td>
                                            <td>
                                                <span className="crm-status-badge">
                                                    {item.lead_type
                                                        ? item.lead_type
                                                              .replaceAll("_", " ")
                                                              .replace(/^\w/, (c) =>
                                                                  c.toUpperCase()
                                                              )
                                                        : "-"}
                                                </span>
                                            </td>
                                            <td>{item.times_asked ?? 0}</td>
                                            <td>
                                                <span className="crm-status-badge">
                                                    {item.status
                                                        ? item.status
                                                              .replaceAll("_", " ")
                                                              .replace(/^\w/, (c) =>
                                                                  c.toUpperCase()
                                                              )
                                                        : "-"}
                                                </span>
                                            </td>
                                            <td>{item.asked_at || "-"}</td>
                                            <td>{item.answered_at || "-"}</td>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-center gap-1">
                                                    <button
                                                        className="st-action-btn st-view-btn"
                                                        onClick={() =>
                                                            navigate(
                                                                `/view-call-detail/${item.id}`
                                                            )
                                                        }
                                                        title="View"
                                                    >
                                                        <FaEye />
                                                    </button>

                                                    {/* ✅ Edit / Add Answer — navigate to page */}
                                                    <button
                                                        className="st-action-btn st-edit-btn"
                                                        onClick={() =>
                                                            navigate(
                                                                `/ai-question-answer/${item.id}`,
                                                                {
                                                                    state: {
                                                                        question: item.question,
                                                                        answer: item.answer,
                                                                        lead_type: item.lead_type,
                                                                    },
                                                                }
                                                            )
                                                        }
                                                        title="Add / Edit Answer"
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            No Questions Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {totalPages > 1 && (
                            <div className="d-flex justify-content-end mt-3">
                                <Pagination
                                    page={page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AiCallingBugsQusetions;